<section class="main-container without-login login-page">
    <div class="container">
        <div class="login-content">
            <!-- <div class="flex-justify-center ">
                <div class="logo">
                    <img src="../../../../assets/images/svg/logo_green.svg" alt="" >
                </div>
            </div> -->
  <!-- this is specifically for login-page-->         
            <h4 class="login-heading">Client Login</h4>

            <!-- <div class="login-mail">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Email address*</mat-label>
                    <input matInput  placeholder="Email address*">
                  </mat-form-field>

            </div> -->
            <form [formGroup]="applicationForm" autocomplete="off">
                <div class="login-mail">
                    <mat-form-field class="example-full-width" appearance="fill">
                        <mat-label>Email address*</mat-label>
                        <input  matInput  formControlName="username"
                        type="text" autocomplete="off"
                        autocorrect="off"
                        autocapitalize="none"
                        (keyup)="onEmailKeyup()"
                        spellcheck="false"  placeholder="Email address*">
                        
                        <mat-error
                        *ngIf="
                          submitted &&
                          applicationF.username.errors &&
                          applicationF.username.errors.required
                        "
                        class="error-message"
                        >Username is required</mat-error
                      >
                      </mat-form-field>
    
                </div>
            <!-- <div class="login-password">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Password*</mat-label>                   
                    <input matInput   placeholder="Password*" >
                  </mat-form-field>

            </div> -->
            <div class="login-password">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Password*</mat-label>                   
                    <input matInput formControlName="password"  placeholder="Password*"
                [type]="hide ? 'password' : 'text'" />
              
                <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon matSuffix class="material-icons-outlined email-icon-login">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                  </button>
                <mat-error
                  *ngIf="
                    submitted &&
                    applicationF.password.errors &&
                    applicationF.password.errors.required
                  "
                  >Password is required</mat-error
                >
                   
                  </mat-form-field>

            </div>
            <!-- <div class="user-id-checkbox">

                <mat-checkbox class="save-id"> Save my user id for next time</mat-checkbox>
            </div> -->
            <button mat-button class="login-submit" mat-flat-button
            cdkFocusInitial            
            [disabled]="submitted"
            (click)="onSubmit()"
          >
            {{ loginText }} <svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M30.7071 8.70711C31.0976 8.31658 31.0976 7.68342 30.7071 7.29289L24.3431 0.928932C23.9526 0.538408 23.3195 0.538408 22.9289 0.928932C22.5384 1.31946 22.5384 1.95262 22.9289 2.34315L28.5858 8L22.9289 13.6569C22.5384 14.0474 22.5384 14.6805 22.9289 15.0711C23.3195 15.4616 23.9526 15.4616 24.3431 15.0711L30.7071 8.70711ZM0 9H30V7H0V9Z" fill="white"/>
              </svg>
              </button>

                <div class="register-user" margin-top2>
                    <a  [routerLink]="" (click)="onRegister()">Click here to register.</a>
                </div>
                <div class="forget-password margin-top2">
                    <a  href="javascript:void(0);" (click)="forgotPassword()">Forgot your password?</a>
                </div>
            </form>>         
        </div>   
    </div>
</section>